import { Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';

/**
 * Protected route wrapper for admin-only pages
 * Checks if user is authenticated as an admin
 */
const AdminProtectedRoute = () => {
    const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Check if user has admin session
        fetch('/pingauth', {
            method: 'GET',
            credentials: 'include'
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Not authenticated');
            })
            .then(data => {
                // Check if the IsAdmin flag is set in the session
                setIsAdmin(data.isAdmin === true);
                setIsLoading(false);
            })
            .catch(() => {
                setIsAdmin(false);
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-gray-100 mx-auto"></div>
                    <p className="mt-4 text-gray-600 dark:text-gray-400">Verifying admin access...</p>
                </div>
            </div>
        );
    }

    if (!isAdmin) {
        // Redirect to login if not admin
        return <Navigate to="/login" replace />;
    }

    // Render child routes if admin
    return <Outlet />;
};

export default AdminProtectedRoute;
